// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"120":"booking-details","242":"room-type","319":"complete","345":"location","540":"personal-details","764":"payment"}[chunkId] || chunkId) + "." + {"120":"59e548f7","242":"93719ce0","319":"6792c11e","345":"6ed312b9","474":"72a6e2db","540":"2fe823e4","764":"83ad71fe"}[chunkId] + ".css";
};